




























import { Component, Vue, Prop } from "vue-property-decorator";
import { ia_agent } from "@/shared/classes/ia_agents_store";

@Component({ components: {} })
export default class agent_list extends Vue {
  @Prop({ type: Array, required: true }) agents!: ia_agent[];
}
